const pageHeader = document.querySelector(`.page-header`);

window.addEventListener(`scroll`, (evt) => {
  let fromTop = window.scrollY;

  if (pageHeader.offsetTop === fromTop) {
    pageHeader.classList.remove(`page-header--fixed`);
  }
  if (pageHeader.offsetTop < fromTop) {
    pageHeader.classList.add(`page-header--fixed`);
  }
});